import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SeismicSwathNoDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-seismicswathno',
  templateUrl: './seismicswathno.component.html',
  styleUrls: ['./seismicswathno.component.scss']
})
export class SeismicSwathNoComponent implements OnInit {


    seismicswathnoForm: FormGroup;
    seismicswathnoFormArray: FormGroup;
  control = new FormControl();
  @Input() seismicswathnos: SeismicSwathNoDto[];
  @Input() routeAnimationsElements: any;
  @Output() seismicswathno = new EventEmitter<SeismicSwathNoDto[]>()
  @Output() deleteSeismicSwathNoEvent = new EventEmitter<any>()

    selectedSeismicSwathNo: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnInit() {
      this.createSeismicSwathNoForm();
    }

    createSeismicSwathNoForm() {
      this.seismicswathnoForm = this.fb.group({
        SwathName: ['', Validators.required],
        SwathNo: [''],
        SwathDescription: ['', Validators.required],
        id: null
        });
        this.seismicswathnoFormArray = this.fb.group({ SeismicSwathNos: this.fb.array([])
          });
          if(this.seismicswathnos != null && this.seismicswathnos.length) {
            this.setSeismicSwathNo();
          }
        
    }

  // method to display seismicswathnos
  setSeismicSwathNo() {
    const control  = this.seismicswathnoFormArray.controls.SeismicSwathNos as FormArray;
    this.seismicswathnos.forEach( e => {
      control.push(
        this.fb.group({
          SwathName: e.SwathName,
          SwathNo: e.SwathNo,
          SwathDescription: e.SwathDescription,
          id: e.id
        })
      );
    });
  }


  // method to add seismicswathno
  addSeismicSwathNo(value: SeismicSwathNoDto) {
    const control  = this.seismicswathnoFormArray.controls.SeismicSwathNos as FormArray;
    control.insert(0,
          this.fb.group({
            SwathName: value.SwathName,
            SwathNo: value.SwathNo,
            SwathDescription: value.SwathDescription,
            id: null
          })
       );
  }

  selectSeismicSwathNo(value) {}

  // method to delete division from arrary list
  deleteSeismicSwathNo(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.seismicswathnoFormArray.controls.SeismicSwathNos as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.seismicswathnos.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.seismicswathnos[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: SeismicSwathNoDto) {
    if(this.seismicswathnoForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.seismicswathnoFormArray.get('SeismicSwathNos')['controls'][this.selectedIndex].patchValue({SwathName: formValue.SwathName, SwathNo: formValue.SwathNo, SwathDescription: formValue.SwathDescription});
    } else {
      this.addSeismicSwathNo(formValue);
    }
    this.selectedIndex = null;
    this.seismicswathnoForm.reset()
  }

  onEdit(index, value: SeismicSwathNoDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.seismicswathnoForm.patchValue({SwathName: value.SwathName, SwathNo: value.SwathNo, SwathDescription: value.SwathDescription});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.seismicswathnoForm.reset();
  }

  onSubmit(formValue: SeismicSwathNoDto[]) {  

  this.seismicswathno.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteSeismicSwathNoEvent.emit(this.filteredDelete);
  }
  }

}
